module.exports = __webpack_public_path__ + "img/fone-pay.896386a0.png";